import { StandardResponse } from '@/types/common';
import {
  Cohort,
  CreateCohortPayload,
  UpdateCohortPayload,
} from '@/types/cohort';
import axiosInstance from './utils/axios';

const BASE_URL = '/agentos/cohorts/';
const MY_COHORTS_URL = '/agentos/my-cohorts/';

const CohortService = {
  getCohorts: async (
    filters?: Record<string, unknown>
  ): Promise<StandardResponse<Cohort>> => {
    const { data } = await axiosInstance.get(BASE_URL, { params: filters });
    return data;
  },

  getMyCohorts: async (): Promise<StandardResponse<Cohort>> => {
    const { data } = await axiosInstance.get(MY_COHORTS_URL);
    return data;
  },

  getCohortById: async (id: number): Promise<Cohort> => {
    const { data } = await axiosInstance.get(`${BASE_URL}${id}/`);
    return data;
  },

  createCohort: async (payload: CreateCohortPayload): Promise<Cohort> => {
    const { data } = await axiosInstance.post(BASE_URL, payload);
    return data;
  },

  updateCohort: async (
    id: number,
    payload: UpdateCohortPayload
  ): Promise<Cohort> => {
    const { data } = await axiosInstance.patch(`${BASE_URL}${id}/`, payload);
    return data;
  },

  deleteCohort: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${BASE_URL}${id}/`);
  },
};

export default CohortService;
